module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: ['btn', _vm.type, {
      readonly: _vm.boolReadonly
    }],
    attrs: {
      "href": "javascript:void(0)",
      "disabled": _vm.boolDisabled
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    class: ['glyphicon', 'glyphicon-' + (_vm.value ? 'ok' : 'remove')]
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.name) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.active ? 1 : 0
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1823c8e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1823c8e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ToggleButton.vue
// module id = 181
// module chunks = 0